import styled from 'styled-components';

export const IconStyle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  display: flex;
`;
